export default "__VITE_ASSET__eadfbcdd__"